export const footer = {
  footerTitleGame: "Los mejores juegos",
  footerTitleGameCasino: "Casino",
  footerTitleGameLottery: "Lotería",
  footerTitleGameGames: "Juegos",
  footerTitleSports: "Deportes",
  footerTitleGameSlots: "Slots",
  footerTitleGameMinigame: "Minijuegos",
  footerTitleTestimonials: "Testimonios",
  footerTitleNews: "Noticias",
  footerTitleLiga: "Las ligas ganadoras",
  footerTitleLigaEsports: "E-Sports",
  footerTitleLigaLeague: "La Liga",
  footerTitleLigaFootball: "Liga de Campeones de la UEFA",
  footerTitleSupport: "Soporte",
  footerTitleHelp: "Centro de ayuda",
  footerTitleTerms: "Términos y condiciones",
  footerTitleSocial: "Síguenos",
  footerTitleApp: "Descarga nuestra app",
  footerTitlePromotions: "Promociones",
  footerTitleResponsibleGambling: "Juega con responsabilidad. Solo para mayores de 18 años.",
  footerTitleSafeGame: "Todo por un juego más seguro",
  footerInfoTitle: "Información",
  footerCategoriesTitle: "Categorías",
  footerContactSupport: "Chatea con nosotros",
  footerSupportDesc: "¿Alguna duda? Estamos acá.",
  footerPromoTitle: "Giros gratis en tu primer depósito",
  footerPromoDesc: "1 giro gratis por cada 40 Bs en tu primer depósito",
  footerPromoAvailable: "Disponible para Android y iOS",
  footerWinAppTitle: "Descarga la app para Windows y juega en tu PC",
  footerInstallBtn: "Instalar",
  footerRegisterBtn: "Regístrate",
  footerGPlayTitle: "Descarga en Google Play",
  footerGPlayDesc: "La mejor experiencia de juego en tu Android",
  footerIOSTitle: "Descarga en App Store",
  footerIOSDesc: "Disponible para iPhone y iPad",
  footerDownloadBtn: "Descargar",
  footerGetItOn: "CONSÍGUELO EN",
  footerDownloadOn: "Descárgalo en",
};
